<template>
    <l-feature-group name="plate-boundaries">
      <l-geo-json
        :geojson="plateBoundaries"
        :options="plateBoundariesOptions"
        :options-style="plateBoundariesStyle"
        />
      <l-feature-group name="plate-boundaries-wrapped" v-if="wrappedMarkers">
        <l-geo-json
          :geojson="plateBoundaries"
          :options="plateBoundariesOptionsRight"
          :options-style="plateBoundariesStyle"
          />
    
        <l-geo-json
          :geojson="plateBoundaries"
          :options="plateBoundariesOptionsLeft"
          :options-style="plateBoundariesStyle"
          />
      </l-feature-group>
    </l-feature-group>
</template>

<script>
  console.log("import plateBoundariesData started")
  import plateBoundariesData from '@/assets/json-files/PB2002_boundaries.json'

  export default {
    props: ['wrappedMarkers', 'plateBoundariesOptions', 'plateBoundariesOptionsLeft', 'plateBoundariesOptionsRight', 'plateBoundariesStyle'],
    data: function() {
      console.log("plateBoundaries import finished")
      return {
        plateBoundaries: plateBoundariesData,
      }
    }
  }
</script>
